import { useCallback, useRef, useState } from 'react';
import { AiOutlineFilePdf } from 'react-icons/ai';
import { doPrintCreditNoteToPdf } from '../../../../api/accountsService';
import { MBox, MCustomIconButton } from '../../../../components/Monetize';
import PreviewPdfDrawer from '../../../../components/Monetize/PreviewPdfDrawer/PreviewPdfDrawer';

/**
 * Allow user to click a button to open a drawer and view credit note PDF documents
 */
export const PreviewCreditNotePdfDrawer = ({
  creditNoteId,
}: {
  creditNoteId: string;
}) => {
  const buttonRef = useRef<typeof MCustomIconButton>(null);
  const [isOpen, setIsOpen] = useState(false);

  const fetchDocument = useCallback(async (): Promise<ArrayBuffer | null> => {
    const { data } = await doPrintCreditNoteToPdf(creditNoteId);
    return data;
  }, [creditNoteId]);

  function handleOpen() {
    setIsOpen(true);
  }

  return (
    <MBox position="relative">
      <MCustomIconButton
        ref={buttonRef}
        btnSize={5}
        variant="icon"
        p={3}
        icon={AiOutlineFilePdf}
        aria-label="Preview PDF"
        onClick={handleOpen}
      />
      {isOpen && (
        <PreviewPdfDrawer
          filename={`creditNote-${creditNoteId}`}
          isOpen={isOpen}
          onCloseFocusRef={buttonRef}
          fetchDocument={fetchDocument}
          onClose={() => setIsOpen(false)}
        />
      )}
    </MBox>
  );
};
